import { SxProps, Theme } from '@mui/material';

/**
 * Common grid container styles used across multiple grids
 */
export const baseGridContainerStyles: SxProps<Theme> = {
  '& .e-grid': {
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    fontFamily: 'inherit',
  },
  '& .e-grid .e-gridheader': {
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0',
  },
  '& .e-grid .e-headercell': {
    fontWeight: 600,
    color: '#1e293b',
    fontSize: '14px',
  },
  '& .e-grid .e-row:hover': {
    backgroundColor: '#f8fafc',
  },
  '& .e-grid .e-altrow': {
    backgroundColor: '#ffffff',
  },
};

/**
 * Text input field styles (search, filters)
 */
export const textFieldStyles: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffffff',
    '& fieldset': {
      borderColor: '#e2e8f0',
    },
    '&:hover fieldset': {
      borderColor: '#3b82f6',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3b82f6',
    },
  },
};

/**
 * Secondary icon color
 */
export const secondaryIconColor = '#64748b';

/**
 * Secondary text color
 */
export const secondaryTextColor = '#94a3b8';
